
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
import loges from '../../components/course/loges.vue'

@Component({
  name: 'BusinessOrderDetails',
  components: {}
})
export default class extends Vue {
  @Prop() order_id: string
  @Prop() is_show_order_info: boolean


  orderDetails: any = {
    customer_name: '',
    business_name: '',
    sex: '',
    recommend_employee_id: '',
    connect_employee_id: '',
    sale_employee_id: '',
    audition_teacher_employee_id: '',
    campus_id: '',
    teacher_employee_id: '',
    category: '',
    packet_id: '',
    price: '',
    pay_price: '',
    is_owed: '',
    order_type: '',
    other_name: '',
    pay_type: '',
    number: '',
    status: 0,
    status_remark: '',
    recommend_employee_name: '',
    connect_employee_name: '',
    sale_employee_name: '',
    audition_teacher_employee_name: '',
    campus_name: '',
    teacher_employee_name: ''
  }
  orderId: any = ''
  p_hight: any = window.innerHeight - 100 + 'px'


  @Watch('is_show_order_info')
  getId(newVal,oldVal) {
    if(newVal) {
      this.orderId = this.order_id
      this.getHeight()
      this.getDetail()
    }
  }
  close() {
     this.$emit('close-order', false)
  }
  getHeight() {
    window.onresize = () => {
      this.p_hight = window.innerHeight - 100 + 'px'
    }
  }

  async getDetail() {
    const res: any = await CourseModule.getOrderDetail({ order_id: this.orderId })
    if (res.code === 200) {
      const data = res.data[0]
      for (var i in data) {
        for (var j in this.orderDetails) {
          if (i === j) {
            this.orderDetails[j] = data[i]
          }
        }
      }
    }
  }

  mounted() {}
}
